import { AbstractControl, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ConfirmationDialogComponent } from "../dis-repository/pages/create-port-tariff/confirmation-dialog.component";
import { MaPort } from "../dis-repository/pages/create-port-tariff/port.model";
import { MaPurpose } from "../dis-repository/pages/create-purpose/purpose.model";
import { fields, PA_Item } from "./port-agent-form.model";
import { SubService as PA_ItemSubservice } from "../pda/port-agent-form.model";

export class PdaEditResponse {
    pda_vsl_id: number | null = null;
    status: string | null = null;
    status_name: string | null = null;
    vsl_id: string | null = null;
    roe_loss: number | null = null;
    loss_prevention_pda: string | null = null;
    voyage: number | null = null;
    final_amount: number | null = null;
    port_tariff_rule: PortTariffRule[] = [];
    loss_prevention_fda: string | null = null;
    createdon: string | null = null;
    disbursement_seq: number | null = null;
    port_id: number | null = null;
    ops_pic: string | null = null;
    sm_estimated_amount: number | null = null;
    total_loss_prevented: number | null = null;
    disbursement_id: string | null = null;
    purpose_id: number | null = null;
    agency_nomination_date: string | null = null;
    sm_detailed_entry: string | null = null;
    loss_prevented_reason: string | null = null;
    updatedon: string | null = null;
    comp_id: number | null = null;
    cargo_id: number | null = null;
    invoice_number: string | null = null;
    remarks: string | null = null;
    created_by: string | null = null;
    client_id: number | null = null;
    eta: string | null = null;
    roe_agent: number | null = null;
    sm_ws_chart_ac: string | null = null;
    updated_by: string | null = null;
    portagent_id: number | null = null;
    etd: string | null = null;
    roe_actual_oanda: number | null = null;
    towage_agency_agrement: string | null = null;
    country_id: number | null = null;
    vessel_stay: number | null = null;
    owners_item_rejected: string | null = null;
    pda: PdaDetails = new PdaDetails();
    fda: FdaDetails = new FdaDetails();
    return_status: string | null = null;
    return_message: string | null = null;
    pda_vessel_details: PdaVesselDetails = new PdaVesselDetails();

    constructor(data?: Partial<PdaEditResponse>) {
        if (data) {
            Object.assign(this, data);
            this.pda = new PdaDetails(data.pda);
            this.pda_vessel_details = new PdaVesselDetails(data.pda_vessel_details);
            this.port_tariff_rule = data.port_tariff_rule?.map(rule => new PortTariffRule(rule)) || [];
        }
    }
}

export class PortTariffRule {
    code: string = '';
    total: number = 0;
    service: string = '';
    sub_services: SubService[] = [];

    constructor(data?: Partial<PortTariffRule>) {
        if (data) {
            Object.assign(this, data);
            this.sub_services = data.sub_services?.map(s => new SubService(s)) || [];
        }
    }
}

export class SubService {
    name: string = '';
    purpose: string = '';
    movement: number = 0;
    optional: boolean = false;
    sub_total: number = 0;
    basic_value: string = '';
    formula_result: string = '';
    tariff_percent: string = '';
    operational_flag: string = '';

    constructor(data?: Partial<SubService>) {
        if (data) Object.assign(this, data);
    }
}

export class PdaDetails {
    portagent_pda_amount: number | null = null;
    meraki_pda_amount: number | null = null;
    advance_percentage: number | null = null;
    pda_remittance: number | null = null;
    conversion_rate: number | null = null;
    currency_conversion: number | null = null;
    meraki_pda_data: string | null = null;
    portagent_pda_data: string | null = null;
    is_manual_entry: string = '';
    pda_processing_date: string | null = null;
    pda_received_ops_agent: string | null = null;
    pda_remark: string | null = null;
    pda_eta: string | null = null;
    pda_etd: string | null = null;
    status: number = 0;
    email_to: string | null = null;
    email_cc: string | null = null;
    pda_id: number = 0;
    pda_roe: number = 0;
    pda_vessel_stay: string | null = null;
    pda_vessel_details: string | null = null;
    disbursement_seq: number = 0;
    created_on: string = '';
    updated_on: string = '';
    created_by: string = '';
    updated_by: string | null = null;
    status_name: string | null = null;
    pda_currency_to: string | null = null;
    pda_currency_from: string | null = null;
    pda_custom_calculation: string | null = null;
    is_re_request: string | null = null;
    invoice_ref_no: string | null = null;

    constructor(data?: Partial<PdaDetails>) {
        if (data) Object.assign(this, data);
    }
}
export class FdaDetails {
    portagent_pda_amount: number | null = null;
    meraki_pda_amount: number | null = null;
    advance_percentage: number | null = null;
    pda_remittance: number | null = null;
    conversion_rate: number | null = null;
    currency_conversion: number | null = null;
    meraki_pda_data: meraki_pda_data = new meraki_pda_data();
    portagent_pda_data: string | null = null;
    is_manual_entry: string = '';
    pda_processing_date: string | null = null;
    pda_received_ops_agent: string | null = null;
    pda_remark: string | null = null;
    status: number = 0;
    email_to: string | null = null;
    email_cc: string | null = null;
    pda_id: number = 0;
    pda_roe: number = 0;
    disbursement_seq: number = 0;
    created_on: string | null = null;
    updated_on: string | null = null;
    created_by: string | null = null;
    updated_by: string | null = null;

    constructor(data?: Partial<PdaDetails>) {
        if (data) Object.assign(this, data);
    }
}

export class meraki_pda_data {
    disbursement_seq: string | null = null;
    voyage: number = 0;
    eta: string | null = null;
    etd: string | null = null
    pda_roe: number = 0;
    pda_currency_from: string | null = null;
    pda_currency_to: string | null = null;
    vessel_stay: string | null = null;
    pda_custom_calculation: string | null = null;
    client: client = new client();
    port_agent: port_agent = new port_agent();
    port: port = new port();
    country: country = new country();
    purpose: purpose = new purpose();
    cargo: cargo = new cargo();
    vessel: vessel = new vessel();
    services: services = new services();

    constructor(data?: Partial<meraki_pda_data>) {
        if (data) Object.assign(this, data);
    }
}

export class client {
    client_id: string | null = null;
    name: string | null = null;

    constructor(data?: Partial<client>) {
        if (data) Object.assign(this, data);
    }
}

export class port_agent {
    name: string | null = null;
    address: string | null = null;
    bank_details: bank_details = new bank_details();

    constructor(data?: Partial<port_agent>) {
        if (data) Object.assign(this, data);
    }
}

export class bank_details {
    country_name: string | null = null;
    beneficiary_acc_holder_name: string | null = null;
    bank_name: string | null = null;
    correspondent_account_number: string | null = null;
    current_account_number: string | null = null;
    ifsc_code: string | null = null;
    bik_code: string | null = null;
    swift_code: string | null = null;
    currency: string | null = null;
    inn_code: string | null = null;
    iban_number: string | null = null;
    bic_code: string | null = null;
    branch_address: string | null = null;

    constructor(data?: Partial<bank_details>) {
        if (data) Object.assign(this, data);
    }
}

export class port {
    port_id: string | null = null;
    name: string | null = null;

    constructor(data?: Partial<port>) {
        if (data) Object.assign(this, data);
    }
}

export class country {
    country_id: string | null = null;
    name: string | null = null;

    constructor(data?: Partial<country>) {
        if (data) Object.assign(this, data);
    }
}

export class purpose {
    purpose_id: string | null = null;
    name: string | null = null;

    constructor(data?: Partial<purpose>) {
        if (data) Object.assign(this, data);
    }
}

export class cargo {
    cargo_id: string | null = null;
    type: string | null = null;

    constructor(data?: Partial<cargo>) {
        if (data) Object.assign(this, data);
    }
}

export class vessel {
    vsl_id: string | null = null;
    imo_number: string | null = null;
    name: string | null = null;
    grt: string | null = null;
    rgrt: string | null = null;
    nrt: string | null = null;
    loa: string | null = null;
    beam: string | null = null;
    depth: string | null = null;
    dwt: string | null = null;
    type: string | null = null;
    additional_fields: AddedFields[] = [];

    constructor(data?: Partial<vessel>) {
        if (data) Object.assign(this, data);
    }
}

export class services {
    item: string | null = null;
    additional_charges: string | null = null;
    service_total: string | null = null;
    grand_total: string | null = null;

    constructor(data?: Partial<services>) {
        if (data) Object.assign(this, data);
    }
}

export class PdaVesselDetails {
    vsl_dtls: VesselDetails = new VesselDetails();

    constructor(data?: Partial<PdaVesselDetails>) {
        if (data) {
            this.vsl_dtls = new VesselDetails(data.vsl_dtls);
        }
    }
}

export class VesselDetails {
    vsl_id: string = '';
    imo_number: string = '';
    name: string | null = null;
    grt: string = '';
    rgrt: string | null = null;
    nrt: string = '';
    loa: string = '';
    beam: string = '';
    depth: string = '';
    dwt: string = '';
    type: string | null = null;

    constructor(data?: Partial<VesselDetails>) {
        if (data) Object.assign(this, data);
    }
}
export class AddedFields {
    fieldName: string = "";
    controlName: string = ""
    is_mandatory?: string = "N"
    data_type?: string = "string"

}

// method to calculate the vessel stay
const calculateVesselStay = (eta: Date | string, etd: Date | string): string | null => {
    if (!eta || !etd) return null;
    let etaDate = new Date(eta);
    let etdDate = new Date(etd);
    if (etdDate.getTime() < etaDate.getTime()) {
        return "eta greater than etd";
    }
    const totalMilliseconds = etdDate.getTime() - etaDate.getTime();
    const totalDays = totalMilliseconds / (1000 * 3600 * 24);
    const days = Math.floor(totalDays);

    return `${days + 1}D`;
};
const mergeResponseVesselIntoList = (
    vessels: any[],
    vesselDetails: any
) => {
    const list = Array.isArray(vessels) ? [...vessels] : [];

    if (!vesselDetails?.vessel_id) {
        return list;
    }

    const exists = list.some(
        (v: any) => v.vessel_id === vesselDetails.vessel_id
    );

    if (exists) {
        return list;
    }

    const responseVessel = {
        vessel_id: vesselDetails.vessel_id,
        name: vesselDetails?.vessel_name || vesselDetails?.vessel || '',
        imo_number: vesselDetails?.imo_number || vesselDetails?.vessel_imo || '',
        grt: vesselDetails?.grt?.current || vesselDetails?.grt || '',
        rgrt: vesselDetails?.rgrt?.current || vesselDetails?.rgrt || '',
        nrt: vesselDetails?.nrt?.current || vesselDetails?.nrt || '',
        loa: vesselDetails?.loa?.current || vesselDetails?.loa || '',
        beam: vesselDetails?.beam?.current || vesselDetails?.beam || '',
        depth: vesselDetails?.depth?.current || vesselDetails?.depth || '',
        dwt: vesselDetails?.dwt?.current || vesselDetails?.dwt || '',
        type: vesselDetails?.type?.current || vesselDetails?.type || '',
        additional_fields: vesselDetails?.additional_fields || []
    };

    return [responseVessel, ...list];
};

// method to display the filtered data
const autoCompleteFilter = (field: any, formGroup: FormGroup, filteredOptions: any): void => {
    formGroup.get(field.value)?.valueChanges.subscribe(value => {
        const filterValue = (value || '').toString().toLowerCase();
        const filtered = (field.options || []).filter((opt: any) => {
            const label =
                field.name === 'Cargo' ? opt?.type :
                    (field.name === 'ToCurrency' || field.name === 'FromCurrency') ? opt :
                        opt?.name;
            return label?.toLowerCase().includes(filterValue);
        });
        filteredOptions[field.value] = filtered;
    });
};

const displayFn = (field: any, value: any): string => {
    if (value == null || value === '') return '';

    // Helper to compute id key based on field name
    const keyBase = field?.name?.trim().toLowerCase().replace(/\s+/g, '');
    const idKey = `${keyBase}_id`;

    const options = field?.options || [];

    // 1) Cargo
    if (field?.name === 'Cargo') {
        if (typeof value === 'object') {
            // If you store the full object
            return value?.type ?? value?.name ?? '';
        }
        // If you store an id
        const cargo = options.find((c: any) => c?.cargo_id === value || c?.id === value);
        return cargo?.type ?? cargo?.name ?? '';
    }

    // 2) Currency fields
    if (field?.name === 'ToCurrency' || field?.name === 'FromCurrency') {
        // You might be storing the string (e.g., code) or an object {code, name}
        if (typeof value === 'string') return value;
        return value?.code ?? value?.name ?? '';
    }

    // 3) Additional or default fields
    //    If you store the full option object
    if (typeof value === 'object') {
        // If object has a 'name', display it
        if (value?.name) return value.name;

        // If it's an object with the id key, try to resolve it
        if (value?.[idKey] != null) {
            const match = options.find((opt: any) => opt?.[idKey] === value[idKey]);
            return match?.name ?? '';
        }
        // Fallback
        return '';
    }

    // 4) If you store primitive id or string
    // Try to resolve against options by dynamic id key OR by opt.value
    const match = options.find((opt: any) =>
        opt?.[idKey] === value || opt?.value === value || opt?.name === value
    );

    return match?.name ?? (typeof value === 'string' ? value : '');
};


// Method to retrieve the value of the options field
const getOptionValuefortheFields = (field: any, opt: any, addedFields: any): any => {
    const matchedFields = addedFields.filter((addedField: any) =>
        !fields.some((f: any) => f.name?.trim() === addedField.fieldName?.trim())
    );

    if (field.name === 'ToCurrency' || field.name === 'FromCurrency') {
        return opt;
    }
    // Check for for additional fields
    else if (matchedFields.some((f: any) => f.fieldName === field.name)) {
        return opt.name;
    }
    // For other fields, return the value corresponding to the dynamic field ID
    else {
        const key = `${field.name.trim().toLowerCase().replace(/\s+/g, '')}_id`;
        return opt[key];
    }
};


const addAdditionalFieldsToFieldsArray = (
    port_id: number,
    portList: MaPort[],
    fields: any[],
    portAgentForm: FormGroup,
    addedFields: any[],
    filteredOptions: any,
    fb: FormBuilder
): { fieldName: string, controlName: string }[] => {
    const selectedPort = portList.find(port => port.port_id === port_id);
    if (selectedPort) {
        const addVslFields: any[] = selectedPort.vessel_fields
            .filter((vf: any) => !!vf.field_name)
            .map((vf: any) => {
                let type: "date" | "input" | "select" = "input";
                let options: any[] = [];
                const [splitType, splitData] = vf.data_type?.split(':') || [];
                const controlName = vf.field_name!
                    .trim()

                if (splitType === 'select') {
                    type = "select";
                    options = splitData.split(',').map((option: any) => ({
                        name: option.trim(),
                        value: option.trim()
                    }));
                }

                return {
                    name: vf.field_name as string,
                    value: controlName,
                    type: splitType === "date" ? 'date' : type,
                    data_type: splitType === 'select' ? 'string' : splitType,
                    options: options,
                    is_mandatory: (vf as any).is_mandatory ?? "N"
                };
            });

        addVslFields.forEach(field => {
            const alreadyExists = fields.some(f => f.value === field.value);
            const alreadyInAddedFields = addedFields.some(af => af.controlName === field.value);
            const isRequired = (field as any).is_mandatory === "Y";

            if (field.type === "select") {
                filteredOptions[field.value] = field?.options || [];
            }

            // If field doesn't exist, add to form and the array
            if (!alreadyExists) {
                fields.push(field);
                portAgentForm.addControl(
                    field.value,
                    fb.control(null, isRequired ? Validators.required : [])
                );
            }

            // Add to addedFields only if not already present
            if (!alreadyInAddedFields) {
                addedFields.push({
                    fieldName: field.name,
                    controlName: field.value,
                    is_mandatory: field.is_mandatory ?? "N",
                    data_type: field.data_type ?? "string"
                });
            }

            // Update existing control if it exists
            if (alreadyExists) {
                const existingControl = portAgentForm.get(field.value);
                if (existingControl) {
                    if (existingControl.value === null || existingControl.value === undefined) {
                        existingControl.setValue('');
                    }
                    existingControl.setValidators(isRequired ? Validators.required : []);
                    existingControl.updateValueAndValidity();
                }
            }
        });
    }

    return addedFields;
};




const validateVesselStay = (field: any, formGroup: FormGroup) => {
    const vesselStayControl = formGroup.get(field.value);
    const vesselStayValue = vesselStayControl?.value?.trim();
    const formatRegex = /^(\d+)\s?(Days?|D)$|^(\d+)\s?(H|Hr)$|^(\d+)\s?(Days?|D)\s*(\d+)\s?(H|Hr)$|^(\d+)\s?(H|Hr)\s*(\d+)\s?(Days?|D)$/i;
    const match = vesselStayValue.match(formatRegex);

    if (!match) {
        vesselStayControl?.setErrors({ invalidFormat: true });
        vesselStayControl?.markAsTouched();
        return;
    }

    // Extract days and hours based on regex match groups
    let days = 0;
    let hours = 0;

    // If the format matches days (1D or 3 Days)
    if (match[1] || match[2]) {
        days = parseInt(match[1] || match[2], 10);
    }

    // If the format matches hours (1H or 3 Hr)
    if (match[3] || match[4]) {
        hours = parseInt(match[3] || match[4], 10);
    }

    // If the format contains both days and hours (1D 1H or 1H 1D)
    if (match[5] || match[6]) {
        days = parseInt(match[5] || match[6], 10);
    }

    if (match[7] || match[8]) {
        hours = parseInt(match[7] || match[8], 10);
    }

    // Days should be greater than 0, and hours should be greater than or equal to 0
    if (days < 0 || hours < 0) {
        vesselStayControl?.setErrors({ invalidNumber: true });
        vesselStayControl?.markAsTouched();
        return;
    }
    vesselStayControl?.setErrors(null);
    vesselStayControl?.markAsTouched();
};

// method to convert the minutes to days and hours
const convertMinutesToDaysOrHours = (minutes: number): string => {
    if (!minutes || minutes <= 0) {
        return '0';
    }
    if (minutes < 1440) {
        const hours = Math.floor(minutes / 60);
        return `${hours}H`;
    }
    const days = Math.floor(minutes / (24 * 60));
    const remainingMinutes = minutes % (24 * 60);
    const hours = Math.floor(remainingMinutes / 60);
    if (hours > 0) {
        return `${days}D ${hours}H`;
    }
    return `${days}D`;
};

const getCompanyIdByName = (companyList: any[],): string | null => {
    return companyList.find((company) => company.company_name?.includes("Meraki"))?.company_id || null;
}


const formatToLocalISOString = (dateInput: string | Date): string => {
    const date = new Date(dateInput);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
}

const clearVesselDetails = (formGroup: FormGroup): void => {
    formGroup.patchValue({
        imo_number: null,
        nrt: null,
        grt: null,
        rgrt: null,
        depth: null,
        loa: null,
        beam: null,
        type: null,
        dwt: null,
        vessel_id: null,
        vessel: null
    });
};

const displayClientComment = (clientRemark: string): string => {
    const parts = clientRemark?.split(' -> ');
    const filteredParts = parts?.filter(item => item !== 'null');
    return filteredParts?.join(' -> ');
}


// method to  format the movement
const replaceMovementPart = (movement: string, partIndex: number, replacementValue: string): string => {
    return movement?.split(':').map((part, index) => {
        return index === partIndex ? replacementValue : part;
    }).join(':');
}


const getPurposeName = (purposeList: MaPurpose[], purposeId: number): string => {
    const purpose = purposeList.find((purpose: any) => purpose.purpose_id === purposeId)?.name;
    return purpose || '';
}

const showDataLostWarning = (dialog: any, previousPurposeId: number, portAgentForm: FormGroup, purposeList: MaPurpose[], onConfirm: () => void, onCancel: () => void) => {
    const dialogRef = dialog.open(ConfirmationDialogComponent, {
        disableClose: true,
        panelClass: 'sweet-alert-style',
        data: { header: "Data Loss Warning", text: "Are you sure you want to change the purpose? This will reset the services." }
    });

    dialogRef.afterClosed().subscribe((result: any[]) => {
        if (result) {
            // User confirmed - proceed with purpose change
            const purposeId = portAgentForm.get('purpose_id')?.value;
            const purpose = getPurposeName(purposeList, purposeId);
            onConfirm();
        } else {
            // User cancelled - revert to previous purpose and restore service data
            portAgentForm.get('purpose_id')?.setValue(previousPurposeId);
            onCancel();
        }
    });
}


const filterServicesOnPurpose = (purpose: string, portServiceListItems: PA_Item[]) => {
    const purposeFiltered = portServiceListItems?.filter((item: any) =>
        item.purpose === purpose || item.purpose === null || item.purpose === ''
    ) || [];

    const duplicatedServices = purposeFiltered.filter((item: any, _index: number, arr: any) => {

        const firstIndex = arr.findIndex((i: any) => i.service === item.service);

        let lastIndex = -1;
        for (let i = arr.length - 1; i >= 0; i--) {
            if (arr[i].service === item.service) {
                lastIndex = i;
                break;
            }
        }
        return firstIndex !== lastIndex;
    });

    const exactPurposeDuplicates = duplicatedServices.filter(
        (item: any) => item.purpose === purpose
    );

    const nonDuplicateServices = purposeFiltered.filter((item: any) =>
        !duplicatedServices.some((d: any) => d.service === item.service)
    );

    const finalServiceList = [
        ...nonDuplicateServices,
        ...exactPurposeDuplicates
    ];
    return finalServiceList.map((item: any) => ({
        ...item,
    }));

}

// method to get the main service serial number
const getMainServiceSerialNumber
    = (currentIndex: number, datasource?: any[]): number => {
        if (!datasource || datasource?.length === 0) {
            return 0;
        }
        let mainServiceCount = 0;
        for (let i = 0; i <= currentIndex; i++) {
            if (datasource[i] && !datasource[i].get('isSubService')?.value) {
                mainServiceCount++;
            }
        }
        return mainServiceCount;
    }


const formatServices = (rawItems: any[]): PA_Item[] => {
    return rawItems.map(raw => {
        const item = new PA_Item;

        item.SNO = raw.SNO;
        item.code = raw.code;
        item.total = raw.total;
        item.service = raw.service;
        item.purpose = raw.purpose;
        item.pa_remark = raw.pa_remark;
        item.meraki_feedback = raw.meraki_feedback;
        item.meraki_remark_client = raw.meraki_remark_client;
        item.client_comment = raw.client_comment;
        item.client_option = raw.client_option;
        item.info_msg = raw.info_msg;
        item.negotiate = raw.negotiate;
        item.agreed = raw.agreed;
        item.display_to_client = raw.display_to_client;

        item.subService = (raw.subService || []).map((s: any) => {
            const sub = new PA_ItemSubservice();

            sub.name = s.name;
            sub.purpose = s.purpose;
            sub.basic_value = s.basic_value;
            sub.hide = s.hide;
            sub.unique_key = s.unique_key;
            sub.calculated_basic_value = s.calculated_basic_value;
            sub.movement = s.movement;
            sub.tariff_percent = s.tariff_percent;
            sub.formula_result = s.formula_result;
            sub.optional = s.optional;
            sub.operational_flag = s.operational_flag;
            sub.sub_total = s.sub_total;
            sub.formula_inputs = s.formula_inputs;

            return sub;
        });
        item.total = raw.total !== null && raw.total !== undefined
            ? String(raw.total)
            : '';
        return item;
    });
}


const restrictDecimal = (event: KeyboardEvent, decimalLimit: number): void => {
    const input = event.target as HTMLInputElement;
    const value = input.value;

    // Allow backspace, delete, arrows, tab etc.
    if (['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(event.key)) {
        return;
    }

    // Allow only numbers and dot
    if (!/^[0-9.]$/.test(event.key)) {
        event.preventDefault();
        return;
    }

    // Allow only one decimal point
    if (event.key === '.' && value.includes('.')) {
        event.preventDefault();
        return;
    }

    // Restrict number of decimal places
    if (value.includes('.')) {
        const decimals = value.split('.')[1];
        if (decimals.length >= decimalLimit) {
            event.preventDefault();
        }
    }
}

const getCurrencyFromCountry = (countryList: any[], countryId: number): string => {
    const country = countryList.find((c: any) => c.country_id === countryId);
    const currency = country?.currency?.toString();
    return currency.includes(',')
        ? currency.split(',')[0].trim()
        : currency;
}

// method to filter the currency
const _filterCurrency = (currencyList: string[], value: string): string[] => {
    const filterValue = value?.toLowerCase();
    return currencyList.filter((currency: string) =>
        currency.toLowerCase().includes(filterValue)
    );
}

// method to remove the added additional vessel field if the different port selected
const removeAddedFieldsAndControls = (pdaCreateForm: FormGroup, addedFields: AddedFields[], fields: any[]) => {

    // Remove controls from form
    addedFields.forEach((added: any) => {
        if (pdaCreateForm.contains(added.controlName)) {
            pdaCreateForm.removeControl(added.controlName);
        }
    });
    // Remove fields from fields array
    fields.splice(0, fields.length, ...fields.filter(field =>
        !addedFields.some((added: any) =>
            added.controlName === field.value
        )
    ));
}

// method to remove the field data on focus if the field value is 0
const onTotalFocus = (
    row: AbstractControl,
    type: 'total' | 'totalUsd' | null
) => {
    const control = type ? row.get(type) : row.get('total');

    const value = control?.value;
    row.get('previousTotalValue')?.setValue(value, { emitEvent: false });

    if (Number(value) === 0) {
        control?.setValue(null, { emitEvent: false });
    }
};

const onTotalBlur = (
    row: AbstractControl,
    type: 'total' | 'totalUsd' | null
) => {

    const control = type ? row.get(type) : row.get('total');
    if (!control) return;

    const value = control.value;
    const previousValue = row.get('previousTotalValue')?.value;

    if (
        value === '' ||
        value === null ||
        value === undefined ||
        value === 'undefined'
    ) {
        control.setValue(previousValue ?? null, { emitEvent: false });
    }
};

// method to get additional properties as an array of objects with field details
const getAdditionalPropertiesObjectFromForm = (
    addedFields: AddedFields[],
    formGroup: FormGroup,
    fields: any[]
): Array<{
    field_name: string;
    value: any;
    data_type: string;
    is_mandatory: string;
}> => {
    const additionalPropertiesArray: Array<{
        field_name: string;
        value: any;
        data_type: string;
        is_mandatory: string;
    }> = [];

    const dateFields = fields.filter(field => field.type === 'date').map(field => field.name);
    const processedFields = new Set<string>(); // Prevent duplicates

    addedFields.forEach(({ fieldName, controlName, is_mandatory, data_type }) => {
        // Skip if field already processed
        if (processedFields.has(fieldName)) {
            return;
        }
        processedFields.add(fieldName);

        let value = formGroup.get(controlName)?.value ?? null;

        // Format date fields if needed
        if (dateFields.includes(fieldName) && value) {
            value = formatToLocalISOString(value);
        }

        additionalPropertiesArray.push({
            field_name: fieldName,
            value: value,
            data_type: data_type || 'string',
            is_mandatory: is_mandatory || 'N'
        });
    });
    return additionalPropertiesArray;
};


export {
    calculateVesselStay, autoCompleteFilter, mergeResponseVesselIntoList, displayFn, validateVesselStay, convertMinutesToDaysOrHours, getCompanyIdByName, formatToLocalISOString, clearVesselDetails, displayClientComment, replaceMovementPart, getPurposeName, showDataLostWarning, filterServicesOnPurpose, getMainServiceSerialNumber, formatServices, restrictDecimal, getCurrencyFromCountry, _filterCurrency, getOptionValuefortheFields, addAdditionalFieldsToFieldsArray, removeAddedFieldsAndControls, onTotalBlur, onTotalFocus, getAdditionalPropertiesObjectFromForm
}
